/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsroomguestswithaccount4Inputs */

const en_statsroomguestswithaccount4 = /** @type {(inputs: Statsroomguestswithaccount4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`of them with an account`)
};

const de_statsroomguestswithaccount4 = /** @type {(inputs: Statsroomguestswithaccount4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`davon mit Konto`)
};

/**
* | output |
* | --- |
* | "of them with an account" |
*
* @param {Statsroomguestswithaccount4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsroomguestswithaccount4 = /** @type {((inputs?: Statsroomguestswithaccount4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsroomguestswithaccount4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsroomguestswithaccount4(inputs)
	return de_statsroomguestswithaccount4(inputs)
});
export { statsroomguestswithaccount4 as "statsRoomGuestsWithAccount" }